import React, { FC } from 'react'

interface Props {
  title: string
  progressText: string
  progressAsPercentage: number
  barColor?: string
}

export const ProgressBar: FC<Props> = ({ title, progressText, progressAsPercentage, barColor }: Props) => {
  const progressBarWidth = `${progressAsPercentage > 100 ? 100 : progressAsPercentage}%`

  return (
    <div className="progressbar pb-1">
      <div className="standardcard-content standardcard-labelrow pb-1">
        <span>{title}</span>
        <span>{progressText}</span>
      </div>

      <div className="progressbar-track">
        <div
          className="progressbar-bar-percent"
          style={{
            width: progressBarWidth,
            borderRadius: '0.25rem',
            ...(barColor ? { backgroundColor: barColor } : {})
          }}
        ></div>
      </div>
    </div>
  )
}
